import { Card, CardContent, Typography } from "@mui/material";
import { useMemo } from "react";
import { formatMoney } from "../../../partner-commission/utils/formatMoney";
import MarketGrowthDataTable from "./MarketGrowthDataTable";

const BreakdownTable = ({
  title,
  rows = [],
  labelColumn = "عنوان",
  showAmount = false,
  formatLabel,
}) => {
  const tableRows = useMemo(
    () =>
      rows.map((row) => ({
        id: row.key,
        label: formatLabel ? formatLabel(row.key) : row.key,
        count: row.count ?? 0,
        amount: row.amount ?? 0,
      })),
    [rows, formatLabel]
  );

  const headCells = useMemo(() => {
    const cells = [
      { id: "label", label: labelColumn },
      { id: "count", label: "تعداد", type: "number" },
    ];
    if (showAmount) {
      cells.push({
        id: "amount",
        label: "مبلغ",
        render: (value) => formatMoney(value),
      });
    }
    return cells;
  }, [labelColumn, showAmount]);

  return (
    <Card variant="outlined" sx={{ height: "100%" }}>
      <CardContent>
        <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1.5 }}>
          {title}
        </Typography>
        <MarketGrowthDataTable
          rowKey="id"
          rows={tableRows}
          headCells={headCells}
          showFilter={false}
          showIndex={false}
          showPaging={false}
          tableMinWidth="auto"
          isDashboard
        />
      </CardContent>
    </Card>
  );
};

export default BreakdownTable;
